import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFalgExamListSubmission } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListFlagExamSubmissionSlice = createSlice({
  name: "ListFlagExamSubmissionSlice",
  initialState: {} as IReduxState<IFalgExamListSubmission[]>,
  reducers: {
    listFlagExamSubmission: (
      state,
      _: PayloadAction<IFalgExamListSubmission>
    ) => {
      state.isLoading = true;
    },
    successlistFlagExamSubmission: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistFlagExamSubmission: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistFlagExamSubmission,
  listFlagExamSubmission,
  successlistFlagExamSubmission,
} = ListFlagExamSubmissionSlice.actions;

export default ListFlagExamSubmissionSlice.reducer;
